import { cn } from '@/lib/utils';

interface OwlPostBadgeProps {
  orderId: string;
  className?: string;
}

/**
 * Renders an order tracking ID like `OWL-A7C9-K2`.
 *
 * Accessibility: screen readers will try to pronounce `OWL-A7C9-K2` as
 * "owl, a seven c nine, k two" — readable but mushy. We give it an
 * aria-label that spells it letter-by-letter so it's unambiguous.
 */
export function OwlPostBadge({ orderId, className }: OwlPostBadgeProps) {
  // Read each segment letter-by-letter, with a pause between segments.
  // E.g. "OWL-A7C9-K2" → "O W L, A 7 C 9, K 2" — readable, no "dash" word.
  const spelled = orderId.split('-').map((seg) => seg.split('').join(' ')).join(', ');
  return (
    <span
      aria-label={`Order ${spelled}`}
      className={cn(
        'inline-flex items-center gap-2 rounded-md border-2 border-(--color-galleon-gold) bg-(--color-parchment) px-3 py-1.5 font-display text-base tracking-wider text-(--color-ink)',
        className,
      )}
    >
      <span aria-hidden="true" className="text-(--color-galleon-gold)">✦</span>
      {orderId}
    </span>
  );
}
